import React from 'react';
import { MapPin, Phone, Clock, ArrowUpRight } from 'lucide-react';
import { clinicInfo } from '../../mock';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';

export default function LocationSection({ onBookClick }) {
  return (
    <section className="relative bg-[#0B0B0B] text-[#FAF7F2] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#C8A97E]" />
              <span className="text-[10px] tracking-[0.32em] uppercase text-[#C8A97E]">Beechwood Dental Studio</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              Find us in the <span className="italic text-[#C8A97E]">heart</span> of Waterloo.
            </h2>
            <p className="mt-6 text-[#FAF7F2]/75 leading-relaxed max-w-md">
              We're located in the Beechwood neighbourhood of Waterloo. Our clinic is easily accessible by
              public transit, and free parking is available in our on-site lot.
            </p>

            <div className="mt-8 space-y-5">
              <div className="flex gap-4">
                <MapPin size={18} strokeWidth={1.5} className="text-[#C8A97E] mt-1 flex-shrink-0" />
                <div>
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A97E]">Address</div>
                  <div className="mt-1 text-[#FAF7F2]/90">{clinicInfo.address}</div>
                </div>
              </div>
              <div className="flex gap-4">
                <Phone size={18} strokeWidth={1.5} className="text-[#C8A97E] mt-1 flex-shrink-0" />
                <div>
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A97E]">Phone</div>
                  <div className="mt-1 text-[#FAF7F2]/90">{clinicInfo.phone}</div>
                </div>
              </div>
              <div className="flex gap-4">
                <Clock size={18} strokeWidth={1.5} className="text-[#C8A97E] mt-1 flex-shrink-0" />
                <div>
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A97E]">Hours</div>
                  <div className="mt-1 text-[#FAF7F2]/90">Mon 1pm–6pm · Tue–Thu 9am–5pm · Fri 9am–1pm</div>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button onClick={onBookClick} className="btn-primary bg-[#C8A97E] hover:bg-[#B69463] text-[#0B0B0B] rounded-none h-12 px-7 text-[11px] tracking-[0.28em] uppercase">
                Book Visit <ArrowUpRight size={16} className="ml-2" strokeWidth={1.5} />
              </Button>
              <Link to="/contact" className="h-12 px-7 border border-[#FAF7F2]/40 hover:bg-[#FAF7F2]/10 flex items-center justify-center text-[11px] tracking-[0.28em] uppercase">
                Contact & Hours
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="relative aspect-[4/3] w-full overflow-hidden border border-[#FAF7F2]/10">
              <iframe
                title="Map showing Beechwood Dental Studio at 18 Fischer-Hallman Rd N, Waterloo, ON"
                src="https://maps.google.com/maps?q=18+Fischer-Hallman+Rd+N,+Waterloo,+ON&t=&z=16&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full grayscale-[30%] contrast-[.95]"
                loading="lazy"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
